import { Injectable } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, Router, RoutesRecognized } from '@angular/router';
import { IBreadCrumb } from '@app/shared/components/breadcrumb/breadcrumb.interface';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbsService {
  public breadcrumbs: IBreadCrumb[] = [];

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    this.buildBreadCrumb(this.activatedRoute.snapshot);

    this.router.events.subscribe((event) => {
      if (event instanceof RoutesRecognized) {
        this.buildBreadCrumb(event.state.root);
      }
    });
  }

  public buildBreadCrumb(activatedRouteSnapshot: ActivatedRouteSnapshot): void {
    if (activatedRouteSnapshot instanceof ActivatedRouteSnapshot) {
      let breadcrumbs = [];
      let root = activatedRouteSnapshot;

      while (root.firstChild) {
        let firstChild = root.firstChild;

        if (firstChild?.data?.breadcrumb) {
          let pathFromRoot = firstChild.pathFromRoot;
          let combinedPathFromRoot = [];
          pathFromRoot.forEach(p => {
            if (p?.routeConfig?.path) {
              combinedPathFromRoot.push(p.routeConfig.path);
            }
          });

          breadcrumbs.push({
            label: firstChild.data.breadcrumb,
            url: combinedPathFromRoot.join('/')
          });
        }
        
        root = firstChild;
      }

      this.breadcrumbs = breadcrumbs;
    } else {
      this.breadcrumbs = [];
    }  
  }
  
}
